import { fetchWrapper } from "../FetchWrapper/FetchWrapper"
import Settings from "../../utils/CarrotConfig"

// Matches the DocumentType C# enum value defined in NetCoreApp/NetCoreApp/Data/Signature.cs
// However, the values are strings because they are used in URL query params
// Also, the name is different because DocumentType is a global object that already exists.
// https://developer.mozilla.org/en-US/docs/Web/API/DocumentType
export enum CarrotDocumentType {
  IvfMedicalRecordsConsentForm = "1",
  PregnancyMedicalRecordsConsentForm = "2"
}

// https://developers.docusign.com/docs/esign-rest-api/reference/envelopes/envelopeviews/createrecipient/
export enum DocuSignEvent {
  SigningComplete = "signing_complete",
  FinishLater = "cancel",
  Decline = "decline",
  Exception = "exception",
  FaxPending = "fax_pending",
  SessionTimeout = "session_timeout",
  TokenExpired = "ttl_expired",
  ViewingComplete = "viewing_complete"
}

interface SignatureCompleteMessage {
  event: DocuSignEvent
  documentType: CarrotDocumentType
}

export interface SignatureCompleteEvent {
  data: SignatureCompleteMessage
}

export async function getSignatureForDocument(documentType: CarrotDocumentType): Promise<string> {
  let endpoint = ""
  switch (documentType) {
    case CarrotDocumentType.IvfMedicalRecordsConsentForm:
      endpoint = "ivf-records-consent"
      break
    case CarrotDocumentType.PregnancyMedicalRecordsConsentForm:
      endpoint = "pregnancy-records-consent"
      break
    default:
      throw new Error(`Unknown DocumentType: ${documentType}`)
  }

  const headers = new Headers()
  headers.append("Content-Type", "application/json")
  const requestUrl = `${Settings.CARROT_BACKEND_URL}/api/v2/signature/${endpoint}`
  const response = await fetchWrapper(requestUrl, {
    method: "POST",
    headers,
    credentials: "include"
  })
  return response.text()
}
